export default __webpack_public_path__ + "static/media/welcomeVideo.240acea9.webm";